var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Task "),_c('router-link',{attrs:{"to":{ name: 'tasks-detail', params: { taskId: _vm.data.taskId } }},nativeOn:{"click":function($event){return _vm.emitOnAction.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.data.taskTitle)+" ")]),_vm._v(" was assigned to you. ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }